module.exports = __webpack_public_path__ + "img/shoot_00029.49d716af.png";